import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { postApi } from "services/post_api";
import { startLoadingApp, stopLoadingApp } from "./appSlice";

const initialState = {
  posts: [],
  loading: false,
  error: null,

  pageconfig: {
    totalCount: 0,
    page: 1,
    limit: 10,
    totalPages: 0,
    mySavedPosts: false

  },

  postsCalled: false,
};

export const fetchPosts = createAsyncThunk(
  "posts/fetchPosts",
  async (payload = {}, { rejectWithValue, getState, dispatch }) => {
    const { pageconfig } = getState().posts;
    dispatch(startLoadingApp());
    // console.log('pageConfig', pageconfig);
    const response = await postApi.getAllPosts(
      pageconfig.page, // Page
      pageconfig.limit // Limit
    );
    dispatch(stopLoadingApp());
    return response.response;
  }
);



export const togglelikePost = createAsyncThunk(
  "posts/likePost",
  async ({ postId, status, params }, { rejectWithValue, dispatch }) => {
    try {
      // dispatch(startLoadingApp());
      const response = await postApi.togglelikePost(postId, status, params);
      // dispatch(stopLoadingApp());
      return response.response;
    } catch (error) {
      // dispatch(stopLoadingApp());
      return rejectWithValue(error.message);
    }
  }
);

export const createComment = createAsyncThunk(
  "posts/createComment",
  async ({ postId, comment, community_user = '' }, { rejectWithValue, dispatch }) => {
    try {
      // console.log("Create Comm", postId, comment, community_user)
      const response = await postApi.createComment(postId, comment.text, community_user);
      return response.response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// export const getCommentOfPost = createAsyncThunk(
//   "posts/getCommentOfPost", 
//   async ({ postId }, { rejectWithValue, dispatch }) => {
//     try {
//       const response = await postApi.getCommentOfPost(postId);
//       console.log("Get comment Response", response);
//       return {
//         postId, // Ensure postId is included
//         comments: response.response.comments, // Adjust this to match your API response
//       }; 
//     } catch (error) {
//       return rejectWithValue(error.message);  
//     }
//   }
// )

const postSlice = createSlice({
  name: "posts",
  initialState,
  reducers: {
    setPostsCalled: (state, action) => {
      state.postsCalled = action.payload;
    },
    setPage: (state, action) => {
      state.pageconfig.page = action.payload;
    },

    addAPost: (state, action) => {  
      const existingPostIndex = state.posts.findIndex(post => post._id === action.payload._id);
      if (existingPostIndex !== -1) {
        state.posts[existingPostIndex] = action.payload;
      } else {
        state.posts = [action.payload, ...state.posts];
      }
      // state.posts = [action.payload, ...state.posts];
    },

    setPosts: (state, action) => {
      // console.log('SetPost called');
      state.posts = action.payload;
    },

    updatePostkey: (state, action) => {
      const { postId, key, value } = action.payload;
      const postIndex = state.posts.findIndex((post) => post._id === postId);
      if (postIndex !== -1) {
        state.posts[postIndex][key] = value;
      }
    },

    removeLikeFromPost: (state, action) => {
      const { postId } = action.payload;
      const postIndex = state.posts.findIndex((post) => post._id === postId);
      if (postIndex !== -1) {
        state.posts[postIndex]['likeCount'] = state.posts[postIndex]['likeCount']-1;
      }
    },
    
    deleteAPost: (state, action) => {
      state.posts = state.posts.filter((post) => post._id !== action.payload);
    },
    updateCountforComment: (state, action) => {
      const { postId, count } = action.payload;
      const postIndex = state.posts.findIndex(post => post._id === postId);
      if (postIndex !== -1) {
        state.posts[postIndex].commentCount = count;
      }
    },

    getPost: (state, action) => {
      const { postId } = action.payload;
      return state.posts.find(post => post._id === postId) || null;
    },


  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchPosts.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          if (action.payload.posts) {
            const newPosts = action.payload.posts
              // .filter((newPost) => {
              //   return !state.posts.some(
              //     (oldPost) => oldPost._id === newPost._id
              //   );
              // })
              .map((newPost) => {
                const existingPost = state.posts.find(
                  (oldPost) => oldPost._id === newPost._id
                );
                if (existingPost) {
                  return { ...existingPost, ...newPost };
                }
                return newPost;
              });
            // console.log('NEW POSTS : ', newPosts);
            if(action.payload.page === 1){
              state.posts = [...newPosts];
            }else{
              state.posts = [...state.posts, ...newPosts];
            }
          }
          state.pageconfig.totalCount = action.payload.totalCount;
          state.pageconfig.page = action.payload.page;
          state.pageconfig.limit = action.payload.limit;
          state.pageconfig.totalPages = Math.ceil(
            action.payload.totalCount / action.payload.limit
          );
        }
      })
      .addCase(fetchPosts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      .addCase(togglelikePost.pending, (state) => {
        state.loading = true;
      })
      .addCase(togglelikePost.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPostIndex = state.posts.findIndex(
          (post) => post._id === action.payload.postId
        );
        if (updatedPostIndex >= 0) {
          if (action.meta.arg.status) {
            state.posts[updatedPostIndex].likeCount -= 1;
            const updatedLikes = state.posts[updatedPostIndex].likes.filter(
              (like) => like._id !== action.meta.arg.user._id
            );
            state.posts[updatedPostIndex].likes = updatedLikes;
          } else {
            state.posts[updatedPostIndex].likeCount += 1;
            const updatedLikes = [
              ...state.posts[updatedPostIndex].likes,
              action.meta.arg.user,
            ];
            state.posts[updatedPostIndex].likes = updatedLikes;
          }
        }
      })
      .addCase(togglelikePost.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })


      // create by chakri

      .addCase(createComment.pending, (state) => {
        state.loading = true;
      })
      .addCase(createComment.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPostIndex = state.posts.findIndex(
          (post) => post._id === action.payload.postId
        );
        if (updatedPostIndex >= 0) {
          // Ensure comments is an array before pushing the new comment
          if (!Array.isArray(state.posts[updatedPostIndex].comments)) {
            state.posts[updatedPostIndex].comments = [];
          }
          state.posts[updatedPostIndex].comments.push(action.payload.comment);
        }
      })
      .addCase(createComment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // getCommentOfPost by Aditya
      // .addCase(getCommentOfPost.pending, (state) => {
      //   state.loading = true;
      // })
      // .addCase(getCommentOfPost.fulfilled, (state, action) => {
      //   state.loading = false;
      //   const updatedPostIndex = state.posts.findIndex(
      //     (post) => post._id === action.payload.postId
      //   );
      //   if (updatedPostIndex >= 0) {
      //     state.posts[updatedPostIndex].comments = action.payload.comments;
      //   }
      // })
      // .addCase(getCommentOfPost.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.error.message;
      // });
  },
});


export const { setPostsCalled, setPage, updateCountforComment, addAPost, deleteAPost, updatePostkey, getPost,removeLikeFromPost, setPosts } = postSlice.actions;
export const selectPosts = (state) => state.posts.posts;
export const selectLoading = (state) => state.posts.loading;
export const selectError = (state) => state.posts.error;

export default postSlice.reducer;
